<template>
  <header class="krj-page__header">
    <div class="krj-page__title">
      <span v-if="showBack" class="krj-back" @click="handleBack">
        <i class="el-icon-arrow-left" />返回
      </span>
      <span>{{ title }}</span>
    </div>
    <div class="krj-page__actions">
      <slot name="actions" />
    </div>
  </header>
</template>

<script>
/**
 * PageHeader — 页面标题栏
 * 左侧：可选「返回」+ 页面标题；右侧：操作区 (具名插槽 #actions)。
 * 返回按钮仅 emit `back` 事件，由父页面决定如何关闭标签页并返回。
 */
export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      default: ''
    },
    showBack: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleBack() {
      this.$emit('back')
    }
  }
}
</script>
